import { Box, Typography } from "@mui/material";
import React from "react";

import { monospaceStyle } from "../../theme";
import { CapabilityPartDetail } from "../../types/capabilityPartDetail";
import PartCountedList from "./PartCountedList";

// The names of the two lists, each above its own column
export const SHOWS_UP = "Where it shows up";
export const CLAIMED_TOGETHER = "Claimed together with";

// Whether the part has either list to show
export const hasShowsUp = (part: CapabilityPartDetail): boolean =>
  part.product_categories.items.length > 0 ||
  part.claimed_together.items.length > 0;

// One list in its column, under a heading of its own with its count
const Column: React.FC<{
  title: string;
  list: CapabilityPartDetail["claimed_together"];
}> = ({ title, list }) => (
  <Box role="group" aria-label={title}>
    <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mb: 1 }}>
      <Typography variant="h6" component="h3">
        {title}
      </Typography>
      <Box
        component="span"
        sx={{
          ...monospaceStyle,
          fontSize: "0.8125rem",
          color: "text.secondary",
        }}
      >
        {list.total}
      </Box>
    </Box>
    <PartCountedList items={list.items} total={list.total} bars={false} />
  </Box>
);

/**
 * Where the products claiming the part show up, by the classes they are
 * filed under, and the other parts of the same role they are claimed
 * together with: two lists side by side, each count "a of b" without a
 * bar. A list without an entry is left out.
 */
const PartShowsUp: React.FC<{ part: CapabilityPartDetail }> = ({ part }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      columnGap: 4,
      rowGap: 2.5,
    }}
  >
    {part.product_categories.items.length > 0 && (
      <Column title={SHOWS_UP} list={part.product_categories} />
    )}
    {part.claimed_together.items.length > 0 && (
      <Column title={CLAIMED_TOGETHER} list={part.claimed_together} />
    )}
  </Box>
);

export default PartShowsUp;
